import { render, staticRenderFns } from "./CommonTNC.vue?vue&type=template&id=bd16acea&scoped=true&"
import script from "./CommonTNC.vue?vue&type=script&lang=js&"
export * from "./CommonTNC.vue?vue&type=script&lang=js&"
import style0 from "./CommonTNC.vue?vue&type=style&index=0&id=bd16acea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd16acea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd16acea')) {
      api.createRecord('bd16acea', component.options)
    } else {
      api.reload('bd16acea', component.options)
    }
    module.hot.accept("./CommonTNC.vue?vue&type=template&id=bd16acea&scoped=true&", function () {
      api.rerender('bd16acea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/CommonTNC.vue"
export default component.exports